let PACKAGE = {
  PACKAGE_IDS: {
    COURSE_PLANNING: 'PKG_COURSE_PLANNING_001',
    EXPLORE: 'PKG_EXPLORE_001',
    EXTERNAL_COURSES: 'PKG_EXTERNAL_COURSES_001',
    DASHBOARD: 'PKG_DASHBOARD_001',
    CLEARLY_NEXT: 'PKG_CLEARLY_NEXT_001'
  },
  FEATURE_IDS: {
    SHOW_RESOURCE_RATING : 'resource_rating',
    PROFILE_FEATURE_ID: 'Profile_Pop_up',
    TOUR_FEATURE_ID: 'tour',
    LEGEND_FEATURE_ID: 'legend',
    STUDENT_PROGRESS_FEATURE_ID: 'student_progress',
    ENROLLED_COURSES_FEATURE_ID: 'enrolled_courses',
    RECOMMENDATIONS_FEATURE_ID: 'recommendations',
    STREAM_RECOMMENDATIONS_FEATURE_ID: 'stream_recommendations',
    QUICK_LINKS_FEATURE_ID: 'quick_links',
    URGENT_NOTIFICATIONS_FEATURE_ID: 'urgent_notifications',
    ADVISTOR_DASHBOARD_FEATURE_ID: 'advisor_dashboard',
    CHANNELS_FEATURE_ID: 'channels',
    TIME_VIEW_FEATURE_ID: 'time_view',
    PROGRESS_VIEW_FEATURE_ID: 'progress_view',
    MASTER_SEARCH_FEATURE_ID: 'all_search',
    COURSE_SEARCH_FEATURE_ID: 'course_search',
    CATALOG_SEARCH_FEATURE_ID: 'catalog_search',
    TAG_SEARCH_FEATURE_ID: 'tag_search',
    SHARING_FEATURE_ID: 'sharing',
    ADD_TO_STREAM_FEATURE_ID: 'add_to_stream',
    SCHEDULE_CHECK_FEATURE_ID: 'schedule_check',
    PRE_REQ_FEATURE_ID: 'pre_req_check',
    PLANNER_VIEW_FEATURE_ID: 'planner_view',
    PLAN_STREAM_FEATURE_ID: 'plan_stream',
    PLAN_STREAM_CATALOGS_FEATURE_ID: 'plan_stream_catalogs',
    PLAN_STREAM_OTHER_ENTITIES_FEATURE_ID: 'plan_stream_other_entities',
    CLEARLY_NEXT_FEATURE_ID: 'clearly_next',
    EXPLORE_INSIGHTS: 'explore_insights',
    ACADEMIC_ALUMNI_INSIGHTS_FEATURE_ID: 'Academic_Alumni_Insights',
    BACKGROUND_ALUMNI_INSIGHTS_FEATURE_ID: 'Background_Alumni_Insights',
    CAREER_ALUMNI_INSIGHTS_FEATURE_ID: 'Career_Alumni_Insights',
    PIVOTS_FEATURE_ID: 'Pivots',
    EXPLORE_FEATURE_ID: 'explore',
    BOOKMARK_FEATURE_ID: 'showBookmark',
    EXPLORE_SEARCH_FEATURE_ID: 'explore_search',
    EXPLORE_SEARCH_EMSI_SOURCE: 'EMSI',
    EXPLORE_SEARCH_BGT_SOURCE: 'BGT',
    EXPLORE_SEARCH_LIGHTCAST_SOURCE: 'LIGHTCAST',
    EXPLORE_PROGRAMS: 'explore_programs',
    EXPLORE_PROGRAM_DETAIL: 'explore_program_detail',
    EXPLORE_CAREERS: 'explore_careers',
    EXPLORE_CAREER_DETAIL: 'explore_career_detail',
    EXPLORE_PROGRAM_CUSTOM_TAGS_FEATURE_ID: 'explore_program_custom_tags',
    CHANNEL_CAN_SEND_FEATURE_ID: 'Can_Send_Messages',
    CHANNEL_SHOW_URGENT_NOTIFICATIONS_TAG: 'show_urgent_notifications_tag',
    CHANNEL_SHOW_MESSAGE_TIMESTAMP: 'show_message_timestamp',
    ZENDESK_FEATURE_ID: 'zendesk',
    STREAM_EXPORT: 'stream_export',
    EXCLUDED_COURSES_FEATURE_ID: 'excluded_courses',
    SKILL_TAGGING_FEATURE_ID: 'skill_tagging',
    SKILL_TAGGING_LEVELS_FEATURE_ID: 'skill_tagging_levels',
    SEND_PROGRESS_EMAIL: 'send_progress_email',
    SHOW_EDUCATION_LEVEL: 'showEducationLevel',
    CUSTOM_CREDIT_LABEL_FEATURE_ID: 'custom_credit_label',
    SHOW_CATALOG_SOURCE: 'showCatalogSource',
    SHOW_XPRIZE_DATA_OPT_OUT: 'xprize_data_opt_out',
    SHOW_LEARNER_DASHBOARD_FEATURE_ID: 'learner_dashboard',
    INSTITUTION_CAREERS: 'institutionCareers',
    PAYMENT_INTEGRATION: 'payment_integration',
    CALENDAR: 'calendar',
    SHOW_MY_PROGRAMS_MENU : 'Show My Programs Menu',
    JOB_BOARD: 'Job Board',
    EMPLOYER_BOARD: 'Employer Board',
  },
  LEGEND_FLAG_LIST: [
    'showDashboardLegend',
    'showProgressLegend'
  ],
  STUDENT_PROGRESS_FLAG_LIST: [
    'showYearOfCompletion'
  ],
  ADVISTOR_DASHBOARD_FLAG_LIST: [
    'automaticStreamShare',
    'showStudentPopover',
    'redirectStreamToProgressView',
    'lockStream',
    'advisorNotes'
  ],
  PROGRESS_VIEW_FLAG_LIST: [
    'showCreditProgress',
    'showCourseProgress',
    'showCourseProgressOnOverall'
  ],
  COURSE_SEARCH_FLAG_LIST: [
    'savedSearch',
    'showSemesterCriteria',
    'showDivisionCriteria',
    'showDepartmentCriteria',
    'showSubjectCriteria',
    'showInstructorCriteria',
    'showMajorsCriteria',
    'showUnitsCriteria',
    'showUnitsOnResult',
    'showCourseSearchFlagCriteria',
    'showDaysCriteria',
    'showTimeCriteria',
    'showGradeLevelCriteria',
    'showBlockCriteria',
    'showInstructorOnResult',
    'showSectionOnResult',
    'showCRNOnResult',
    'showMeetingDaysOnResult',
    'showMeetingTimesOnResult',
    'showEnrollmentOnResult',
    'showCreditOnResult',
    'showRoomInformationOnResult',
    'showSpecialInstructionsOnResult',
    'showGradeLevelOnResult',
    'showBlockOnResult',
    'showYearCriteria',
    'enableSearchByAnySemester'
  ],
  CATALOG_SEARCH_FLAG_LIST: [
    'showDivisionCriteria',
    'showDepartmentCriteria',
    'showSubjectCriteria'
  ],
  ADD_TO_STREAM_FLAG_LIST: [
    'showRemove'
  ],
  SCHEDULE_CHECK_FLAG_LIST: [
    'showCourseTitle',
    'showShare',
    'showPrint',
    'showCalExport',
    'showGoogleCalSync',
    'showCRN',
    'showCourseTitle',
    'showDays',
    'showTime',
    'showUnits',
    'showInstructor',
    'showBlock',
    'showGradeLevel'
  ],
  RECOMMENDATIONS_FLAG_LIST: [
    'showAlumniStreamRecommendations',
    'showAdvisorStreamRecommendations'
  ],
  EXPLORE_PROGRAM_CUSTOM_TAGS_FLAG_LIST: [
    'Werth'
  ],
  SKILL_TAGGING_FLAG_LIST: [
    'sourceEMSI',
    'course',
    'catalog',
    'job',
    'club'
  ],
  SKILL_TAGGING_LEVELS_FLAG_LIST: [
    'Beginner',
    'Intermediate',
    'Expert',
    'Genius'
  ],
  CLEARLY_NEXT_FLAG_LIST: [
    'showAccountSubscription'
  ]
}

let featureIdsToFlags = {}
let _ = PACKAGE
let _ids = _.FEATURE_IDS
featureIdsToFlags[_ids.LEGEND_FEATURE_ID] = _.LEGEND_FLAG_LIST
featureIdsToFlags[_ids.STUDENT_PROGRESS_FEATURE_ID] = _.STUDENT_PROGRESS_FLAG_LIST
featureIdsToFlags[_ids.ADVISTOR_DASHBOARD_FEATURE_ID] = _.ADVISTOR_DASHBOARD_FLAG_LIST
featureIdsToFlags[_ids.PROGRESS_VIEW_FEATURE_ID] = _.PROGRESS_VIEW_FLAG_LIST
featureIdsToFlags[_ids.COURSE_SEARCH_FEATURE_ID] = _.COURSE_SEARCH_FLAG_LIST
featureIdsToFlags[_ids.CATALOG_SEARCH_FEATURE_ID] = _.CATALOG_SEARCH_FLAG_LIST
featureIdsToFlags[_ids.ADD_TO_STREAM_FEATURE_ID] = _.ADD_TO_STREAM_FLAG_LIST
featureIdsToFlags[_ids.SCHEDULE_CHECK_FEATURE_ID] = _.SCHEDULE_CHECK_FLAG_LIST
featureIdsToFlags[_ids.STREAM_RECOMMENDATIONS_FEATURE_ID] = _.RECOMMENDATIONS_FLAG_LIST
featureIdsToFlags[_ids.SKILL_TAGGING_FEATURE_ID] = _.SKILL_TAGGING_FLAG_LIST
featureIdsToFlags[_ids.SKILL_TAGGING_LEVELS_FEATURE_ID] = _.SKILL_TAGGING_LEVELS_FLAG_LIST
featureIdsToFlags[_ids.CLEARLY_NEXT_FEATURE_ID] = _.CLEARLY_NEXT_FLAG_LIST
featureIdsToFlags[_ids.EXPLORE_PROGRAM_CUSTOM_TAGS_FEATURE_ID] = _.EXPLORE_PROGRAM_CUSTOM_TAGS_FLAG_LIST

export { PACKAGE, featureIdsToFlags }



// WEBPACK FOOTER //
// ./src/package_constants.js